module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="onemodal '+
((__t=( content.theme ))==null?'':__t)+
'">\n	<div class="box-content">\n		<div class="box-inner">\n			<span class="loading"></span>\n		</div>\n		<div class="inner-loading-container hide" id="quickshop-inner-loader">\n	    	<div class="loading"></div>\n	    	<div class="message"></div>\n	    </div>\n	    <div class="close"></div>\n	</div>\n	<div class="close"></div>\n	<div class="overlay"></div>\n</div>';
}
return __p;
};
